








// @ is an alias to /src
import { Component, Vue, Watch } from 'vue-property-decorator'
import { AloSejour, getDefaultAloSejour } from '@/models/alo/AloSejour'

@Component({
  name: 'SejourDetail',
  props:{   
    sejour:{
      type:Object,
      required:true,
      default:() => getDefaultAloSejour()
    }
  }
})
export default class SejourDetail extends Vue {
    
  private sejour!:AloSejour
 
}
